import { JobEventReporter } from "@/js/eventReport";

class JobEventDispatcher {
    static attach() {
        window.addEventListener("GALoaded", () => {
            JobEventDispatcher.handleJobImpressionEvent();
            JobEventDispatcher.handleJobClickEvent();
        });
    }

    static handleJobImpressionEvent() {
        if (document.querySelector("[data-job-impression]")) {
            const { jobImpression } = document.querySelector("[data-job-impression]").dataset;
            const {
                id,
                enterprise_name: enterpriseName,
                title,
                occupation
            } = JSON.parse(jobImpression);
            JobEventReporter.sendImpression({
                id: `job-${id}`,
                enterpriseName,
                title: `${occupation}-${title}`
            });
        }
    }

    static handleJobClickEvent() {
        [...document.querySelectorAll("[data-job-click]")].forEach((applyButtonElement) => {
            const { jobClick } = document.querySelector("[data-job-click]").dataset;
            const { id, enterprise_name: enterpriseName, title, occupation } = JSON.parse(jobClick);

            applyButtonElement.addEventListener("click", () => {
                JobEventReporter.sendClick({
                    id: `job-${id}`,
                    enterpriseName,
                    title: `${occupation}-${title}`
                });
            });
        });
    }
}

export { JobEventDispatcher };
